import { AuthContext } from "@/providers";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useLoginRouting = () => {
  const [state] = AuthContext.useActor();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.matches("authenticated")) {
      navigate("/app/");
    } else if (state.matches("unverified")) {
      navigate("/auth/verify");
    }
  }, [state, navigate]);
};
